import apiClient from "../config/api";

const oeeService = {
  startRun: async (data) => {
    return (await apiClient.post("/oee/runs", data)).data;
  },
  endRun: async (id, data) => {
    return (await apiClient.post(`/oee/update/runs/${id}/end`, data)).data;
  },
  updateRun: async (id, data) => {
    return (await apiClient.post(`/oee/update/runs/${id}/update`, data)).data;
  },
  deleteRun: async (id) => {
    return (await apiClient.post(`/oee/delete/runs/${id}`)).data;
  },
  getActiveRun: async (machineId) => {
    try {
      const response = await apiClient.get(`/oee/runs/active/${machineId}`);
      if (response.status === 204) return null;
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 404) return null;
      throw error;
    }
  },
  getRun: async (runId) => {
    return (await apiClient.get(`/oee/runs/${runId}`)).data;
  },
  getRecentRuns: async (machineId) => {
    return (await apiClient.get(`/oee/runs/machine/${machineId}`)).data;
  },
  logDowntime: async (data) => {
    return (await apiClient.post("/oee/downtime", data)).data;
  },
  updateDowntime: async (id, data) => {
    return (await apiClient.post(`/oee/update/downtime/${id}`, data)).data;
  },
  deleteDowntime: async (id) => {
    return (await apiClient.post(`/oee/delete/downtime/${id}`)).data;
  },
  logQuality: async (data) => {
    return (await apiClient.post("/oee/quality", data)).data;
  },
  getMetrics: async (runId) => {
    return (await apiClient.get(`/oee/metrics/${runId}`)).data;
  },
  getDowntimeLogs: async (runId) => {
    return (await apiClient.get(`/oee/runs/${runId}/downtime`)).data;
  },
  getQualityLogs: async (runId) => {
    return (await apiClient.get(`/oee/runs/${runId}/quality`)).data;
  },
  getShiftMetrics: async (machineId, shiftId, date) => {
    return (await apiClient.get(`/oee/metrics/shift/${machineId}/${shiftId}/${date}`)).data;
  },
  getShiftRuns: async (machineId, shiftId, date) => {
    return (await apiClient.get(`/oee/runs/shift/${machineId}/${shiftId}/${date}`)).data;
  },
  getSettings: async (tenantId) => {
    return (await apiClient.get(`/OeeSettings/${tenantId}`)).data;
  },
  updateSettings: async (tenantId, settings) => {
    return (await apiClient.post(`/OeeSettings/update/${tenantId}`, settings)).data;
  },
  getShiftStatus: async (machineId, shiftId, date) => {
    return (await apiClient.get(`/ShiftLog/status`, { params: { machineId, shiftId, date } })).data;
  },
  submitShift: async (machineId, shiftId, date) => {
    return (await apiClient.post(`/ShiftLog/submit`, { machineId, shiftId, date })).data;
  },
  reopenShift: async (machineId, shiftId, date) => {
    return (await apiClient.post(`/ShiftLog/reopen`, { machineId, shiftId, date })).data;
  },
};

export default oeeService;
